import request from '@/utils/request'
let preBase = 'mixApi'
import { getCookie } from '@/utils/cookie'

// 多笔立减活动-登录
export const login = (data) => {
  return request({
    url: `${preBase}/wechatMultiAuth/login`,
    method: 'post',
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}

// 多笔立减活动-获取签名
export const getSign = (data) => {
  return request({
    url: `${preBase}/wechatMultiAuth/getSign`,
    method: 'post',
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}

// 多笔立减活动-获取活动信息和上报记录
export const getActAndReportInfo = () => {
  return request({
    url: `${preBase}/wechatMultiReport/getActAndReportInfo`,
    method: 'post',
    token: getCookie('wechatMutipleDiscountToken'),
    hideLoading: true,
    hideErrMsgToast: true,
  })
}

// 多笔立减活动-获取活动信息-无token
export const getActInfo = (data) => {
  return request({
    url: `${preBase}/wechatMulti/getActInfo?bizNo=${data}`,
    method: 'post',
    hideLoading: true,
    hideErrMsgToast: true,
  })
}

// 多笔立减活动-获取上报记录
export const getReportInfo = (data) => {
  return request({
    url: `${preBase}/wechatMultiReport/getReportInfo`,
    method: 'post',
    token: getCookie('wechatMutipleDiscountToken'),
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
// 多笔立减活动-获取验证码
export const getVerCode = (data) => {
  return request({
    url: `${preBase}/wechatMultiReport/getVerCode`,
    method: 'post',
    token: getCookie('wechatMutipleDiscountToken'),
    data,
    hideLoading: true,
  })
}
// 多笔立减活动-上报
export const report = (data) => {
  return request({
    url: `${preBase}/wechatMultiReport/report`,
    method: 'post',
    token: getCookie('wechatMutipleDiscountToken'),
    data
  })
}